'use strict';


function __detectSessionID() {
    let sessionId = '';
    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        sessionId = RegExp.$1;
    }
    return sessionId;
}

let fancybox = {};

let popup = {
    html: '<div class="popup js-popup">'
    + '<div class="popup__top">'
    + '<div class="popup__inner m--nopadding">'
    + '<div class="popup__block">'
    + '<a href="#" class="popup__close js-popup__close"></a>'
    + '</div>'
    + '</div>'
    + '</div>'
    + '<div class="popup__inner js-popup__content"></div>'
    + '</div>',
    selector: '.js-popup'
};

let ajax = {
    type: 'post',
    url: '/json/',
    dataType: 'json',
    timeout: 10000,
    traditional: true,
    SESSION_ID: __detectSessionID(),
    loader_selector: '.loader',
    loader: '<div class="loader"></div>'
};

let yaCounter = 'yaCounter65864155';

let breakpoints = {
    xxl: Infinity,
    xl: 1620,
    l: 1280,
    m: 1000,
    s: 780,
    xs: 600,
    xxs: 420
};


let interfaceName = document.body.dataset['interface'];

let tinymce5 = {
    //mode: "none",
    language: 'ru',
    theme: 'silver',
    skin: 'flexites',
    width: '100%',
    height: 400,
    content_css: [
      '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
    ],
    relative_urls: false,
    //browser_spellcheck : true,

    plugins: 'autolink link lists',
    default_link_target: '_blank',
    menubar: false,
    toolbar: 'undo redo | removeformat | bold italic underline strikethrough | subscript superscript | alignleft aligncenter alignright alignjustify | numlist bullist | link unlink',
    spellchecker_dialog: true,
    spellchecker_whitelist: ['Ephox', 'Moxiecode'],
    fullscreen_new_window: true,
    force_hex_style_colors: true,
    valid_elements: 'a,b,strong,i,p[style],br,ul,ol,li,sub,sup,u,ins,del',
    valid_styles: {
        'p': 'text-align'
    }
    //extended_valid_elements: 'a[name|href|target|title|onclick],hr[class|width|size|noshade]',
/*
    setup: (editor) => {
        editor.on('init', () => {
            editor.getContainer().style.transition='border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
            editor.getContainer().style.borderRadius='4px',
            editor.getContainer().style.borderColor='#ccc'
        });
        editor.on('focus', () => {
            editor.getContainer().style.boxShadow='inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6)',
            editor.getContainer().style.borderColor='#66afe9'
        });
        editor.on('blur', () => {
            editor.getContainer().style.boxShadow='',
            editor.getContainer().style.borderColor=''
        });
    }
*/
    //setup: function (editor) {
    //    editor.ui.registry.addGroupToolbarButton('alignment', {
    //    icon: 'align-left',
    //    tooltip: 'Alignment',
    //    items: 'alignleft | aligncenter | alignright | alignjustify'
    //});
}

export {
    fancybox,
    ajax,
    breakpoints,
    yaCounter,
    interfaceName,
    popup,
    tinymce5
};
